import { render } from "./z-header.vue?vue&type=template&id=20ffbc1c&scoped=true"
import script from "./z-header.vue?vue&type=script&lang=js"
export * from "./z-header.vue?vue&type=script&lang=js"

import "./z-header.vue?vue&type=style&index=0&id=20ffbc1c&lang=scss&scoped=true"

import exportComponent from "D:\\work\\zwkj\\cdzblue\\loginform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20ffbc1c"]])

export default __exports__